import React from 'react';
import { Box, Chip } from '@mui/material';
import { formatBusinessText } from '../../utils/textFormatting';

const Tags = ({ tags = [], sx = {} }) => {
  if (!tags || tags.length === 0) {
    return null;
  }

  return (
    <Box 
      sx={{ 
        mt: 2, 
        pt: 2, 
        borderTop: '1px solid',
        borderColor: 'divider',
        display: 'flex',
        flexWrap: 'wrap',
        gap: 0.5,
        ...sx
      }}
    >
      {tags.map((tag, index) => (
        <Chip
          key={index}
          label={formatBusinessText(tag)}
          size="small"
          variant="outlined"
          sx={{
            fontSize: '0.625rem',
            height: '1.25rem',
            backgroundColor: '#000000',
            color: 'white',
            borderColor: '#000000',
            '& .MuiChip-label': {
              padding: '0 0.5rem',
              fontSize: '0.625rem',
              lineHeight: '1.25rem'
            },
            '&:hover': {
              backgroundColor: '#333333',
              color: 'white',
            }
          }}
        />
      ))}
    </Box>
  );
};

export default Tags;
